import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useState } from "react";
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useMemo } from 'react';
import DeleteRenderer from "../../Components/UserActions";
import UserManagement from "../../Components/UserManagement";
function Staff() {

   
   // Row Data: The data to be displayed.
   const [rowData, setRowData] = useState([
    { FirstName: "Milagros ", LastName: "Betts",  Email: "milagrosbetts@outlook.com", Phone: "415-295-1112",Country: "USA", State: "Alabama",NPN: "102525", DateAndTime: "03-Jan-2024 05:28:14", },
    { FirstName: "Milagros ", LastName: "Betts",  Email: "milagrosbetts@outlook.com", Phone: "415-295-1112",Country: "USA", State: "Alabama",NPN: "102525", DateAndTime: "03-Jan-2024 05:28:14", },
    { FirstName: "Milagros ", LastName: "Betts",  Email: "milagrosbetts@outlook.com", Phone: "415-295-1112",Country: "USA", State: "Alabama",NPN: "102525", DateAndTime: "03-Jan-2024 05:28:14", },
    { FirstName: "Milagros ", LastName: "Betts",  Email: "milagrosbetts@outlook.com", Phone: "415-295-1112",Country: "USA", State: "Alabama",NPN: "102525", DateAndTime: "03-Jan-2024 05:28:14", },
    { FirstName: "Milagros ", LastName: "Betts",  Email: "milagrosbetts@outlook.com", Phone: "415-295-1112",Country: "USA", State: "Alabama",NPN: "102525", DateAndTime: "03-Jan-2024 05:28:14", },
    { FirstName: "Milagros ", LastName: "Betts",  Email: "milagrosbetts@outlook.com", Phone: "415-295-1112",Country: "USA", State: "Alabama",NPN: "102525", DateAndTime: "03-Jan-2024 05:28:14", },
    { FirstName: "Milagros ", LastName: "Betts",  Email: "milagrosbetts@outlook.com", Phone: "415-295-1112",Country: "USA", State: "Alabama",NPN: "102525", DateAndTime: "03-Jan-2024 05:28:14", },
    { FirstName: "Milagros ", LastName: "Betts",  Email: "milagrosbetts@outlook.com", Phone: "415-295-1112",Country: "USA", State: "Alabama",NPN: "102525", DateAndTime: "03-Jan-2024 05:28:14", },
    { FirstName: "Milagros ", LastName: "Betts",  Email: "milagrosbetts@outlook.com", Phone: "415-295-1112",Country: "USA", State: "Alabama",NPN: "102525", DateAndTime: "03-Jan-2024 05:28:14", },
    { FirstName: "Milagros ", LastName: "Betts",  Email: "milagrosbetts@outlook.com", Phone: "415-295-1112",Country: "USA", State: "Alabama",NPN: "102525", DateAndTime: "03-Jan-2024 05:28:14", },
    { FirstName: "Milagros ", LastName: "Betts",  Email: "milagrosbetts@outlook.com", Phone: "415-295-1112",Country: "USA", State: "Alabama",NPN: "102525", DateAndTime: "03-Jan-2024 05:28:14", },
    { FirstName: "Milagros ", LastName: "Betts",  Email: "milagrosbetts@outlook.com", Phone: "415-295-1112",Country: "USA", State: "Alabama",NPN: "102525", DateAndTime: "03-Jan-2024 05:28:14", },
    { FirstName: "Milagros ", LastName: "Betts",  Email: "milagrosbetts@outlook.com", Phone: "415-295-1112",Country: "USA", State: "Alabama",NPN: "102525", DateAndTime: "03-Jan-2024 05:28:14", },
    { FirstName: "Milagros ", LastName: "Betts",  Email: "milagrosbetts@outlook.com", Phone: "415-295-1112",Country: "USA", State: "Alabama",NPN: "102525", DateAndTime: "03-Jan-2024 05:28:14", },
    { FirstName: "Milagros ", LastName: "Betts",  Email: "milagrosbetts@outlook.com", Phone: "415-295-1112",Country: "USA", State: "Alabama",NPN: "102525", DateAndTime: "03-Jan-2024 05:28:14", },
    { FirstName: "Milagros ", LastName: "Betts",  Email: "milagrosbetts@outlook.com", Phone: "415-295-1112",Country: "USA", State: "Alabama",NPN: "102525", DateAndTime: "03-Jan-2024 05:28:14", },
    { FirstName: "Milagros ", LastName: "Betts",  Email: "milagrosbetts@outlook.com", Phone: "415-295-1112",Country: "USA", State: "Alabama",NPN: "102525", DateAndTime: "03-Jan-2024 05:28:14", },
   
   
]);




// Column Definitions: Defines the columns to be displayed.
const [colDefs, setColDefs] = useState([
     
    
    { field: "FirstName" },
    { field: "Actions",
        cellRenderer: DeleteRenderer, 
        cellStyle: { overflow: "visible", zIndex: "auto" },// Set this line
      resizable: true,
      suppressMenu: true,
      minWidth: 100,
      width: 80 
     },
    { field: "LastName" },   
    { field: "Email" },
    { field: "Phone" },
    { field: "Country" },
    { field: "State" },
    { field: "NPN" },
    { field: "DateAndTime" },
]);


// ...
const defaultColDef = useMemo(() => {
    return {
        flex: 1,
        filter: true,
    }

});


   
    

    return (
        <Container fluid>         
           <UserManagement/>
          
            <Row className='m-1 pt-2'>
                <Col sm={4} className='d-flex'>
                    <h6 className='fw-bold'>Staff </h6>
                </Col>
                <Col sm={4} className='pb-2'>
                    
                </Col>
                <Col sm={4} >
                    <div class="dropdown float-end">
                      
                    </div>
                </Col>

                <div className="ag-theme-alpine" // applying the grid theme
                     style={{ height: 550 }} // the grid will fill the size of the parent container
                >
                    <AgGridReact
                        rowData={rowData}
                        columnDefs={colDefs}
                        pagination={true}
                        paginationPageSize={10}
                        paginationPageSizeSelector={[10, 20]}
                        defaultColDef={defaultColDef}
                        rowSelection={"multiple"}
                       
                    />
                </div>
                
               
            </Row>
           
        </Container>

    );
}

export default Staff